import _ from 'lodash'

import {
  QuestionsGroupsByReactiveForms,
} from './forms.selector'

export const getFlow = (form, props) => {
  const {
    formSelected,
    pointSelected,
    stageSelected,
    abstractQuestionsGroup,
    questionsValue,
    finalizeForm,
    Points,
    forms,
    formPointPending = {},
  } = props

  const formsOptions = forms.map(x => ({
    label: x.name,
    value: x._id,
  }))
  const pointsOption = Points.data.map(x => ({
    label: x.name,
    value: x._id,
  }))

  if (!form) {
    return {
      formsOptions,
      points: pointsOption,
      formSelected: null,
      pointSelected: null,
      stageSelected: {
        questionsGroups: [],
      },
      questionsValue: {},
      nextStage: null,
      prevStage: null,
      finalizeForm: false,
    }
  }

  if (form.type === 'flow') {
    const abstractQuestionsGroupIds = abstractQuestionsGroup
      .map(abstract => abstract.questionGroupRef)
    const stages = _.orderBy(form.funnel.stages, 'order')
    const limitPrevPendingStage = formPointPending && formPointPending._id && formPointPending.stage_id
      ? _.findIndex(stages, { _id: formPointPending.stage_id })
      : 0
    const stageIndexSelected = !stageSelected
      ? 0
      : _.findIndex(stages, { _id: stageSelected })

    const stage = stages[stageIndexSelected]
    const nextStage = (stages[stageIndexSelected + 1] || {})._id
    const prevIndex = (stageIndexSelected - 1) < limitPrevPendingStage
      ? -1
      : stageIndexSelected - 1
    const prevStage = (stages[prevIndex] || {})._id
    const completedForm = !nextStage || finalizeForm
    const questionsGroups = stage
      ? _.filter(
        stage.questionsGroups,
        value => (value.type === 'abstract' && abstractQuestionsGroupIds.includes(value._id))
          || value.type === 'normal'
      )
      : []

    return {
      formsOptions,
      points: pointsOption,
      formSelected,
      pointSelected,
      stageSelected: {
        ...stage,
        questionsGroups,
      },
      questionsValue,
      nextStage,
      prevStage,
      finalizeForm: completedForm,
    }
  }

  if (form.type === 'reactive') {
    const abstractQuestionsGroupIds = abstractQuestionsGroup
      .map(abstract => abstract.questionGroupRef)
    const allQuestionsGroups = QuestionsGroupsByReactiveForms(form)
    const questionsGroups = _.filter(allQuestionsGroups, value => (
      (value.type === 'abstract' && abstractQuestionsGroupIds.includes(value._id))
      || value.type === 'normal'
    ))

    return {
      formsOptions,
      points: pointsOption,
      formSelected,
      pointSelected,
      stageSelected: {
        questionsGroups,
      },
      questionsValue,
      nextStage: null,
      prevStage: null,
      finalizeForm,
    }
  }
}
